module.exports = __webpack_public_path__ + "img/user_animated.dd5a56dd.svg";